import { Box, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { RepeatOn, WifiProtectedSetup } from "@mui/icons-material";

const StatBox = ({
  title,
  subtitle,
  icon,
  viewIncomeCustom,
  setViewIncomeCustom,
  showButton,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Paper
      variant="elevation"
      elevation={4}
      display="flex"
      sx={{
        width: "100%",
        height: "100%",
        justifyItems: "center",
        alignContent: "center",
        alignItems: "center",
        padding: "25px",
      }}
    >
      <Box width="100%" m="0 30px">
        {!showButton ? (
          ""
        ) : (
          <Box
            justifyContent="space-between"
            sx={{
              position: "relative",
              pb: "15px",
            }}
          >
            <IconButton
              aria-label="delete"
              onClick={() =>
                setViewIncomeCustom(viewIncomeCustom ? false : true)
              }
            >
              <WifiProtectedSetup color="success" />
            </IconButton>
          </Box>
        )}

        <Box display="flex" justifyContent="space-between">
          <Box>
            {icon}
            <Typography
              variant="h2"
              fontWeight="bold"
              sx={{ color: colors.grey[600] }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" mt="2px">
          <Typography variant="h4" sx={{ color: colors.greenAccent[500] }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default StatBox;
